import { render, staticRenderFns } from "./CommissionListing.vue?vue&type=template&id=1853a828"
import script from "./CommissionListing.vue?vue&type=script&lang=js"
export * from "./CommissionListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports